import React, { useState } from 'react';

// Mapa codigo FIFA (3 letras) -> ISO 3166-1 alpha-2 (pra flagcdn.com).
// Bandeiras nacionais sao de uso livre (nao violam IP do torneio).
// Cobre seleções de futebol comuns; fallback mostra a sigla num badge verde.
const FIFA_ISO = {
  BRA: 'br', ARG: 'ar', URU: 'uy', PAR: 'py', CHI: 'cl', COL: 'co', PER: 'pe',
  ECU: 'ec', VEN: 've', BOL: 'bo', MEX: 'mx', USA: 'us', CAN: 'ca', CRC: 'cr',
  PAN: 'pa', HON: 'hn', JAM: 'jm', SLV: 'sv', GUA: 'gt', HAI: 'ht',
  FRA: 'fr', ESP: 'es', POR: 'pt', GER: 'de', ITA: 'it', NED: 'nl', BEL: 'be',
  CRO: 'hr', SUI: 'ch', SRB: 'rs', POL: 'pl', DEN: 'dk', SWE: 'se', NOR: 'no',
  AUT: 'at', UKR: 'ua', TUR: 'tr', GRE: 'gr', CZE: 'cz', HUN: 'hu', ROU: 'ro',
  RUS: 'ru', SCO: 'gb-sct', WAL: 'gb-wls', ENG: 'gb-eng', IRL: 'ie', NIR: 'gb-nir',
  ISL: 'is', FIN: 'fi', SVK: 'sk', SVN: 'si', ALB: 'al', BIH: 'ba', MKD: 'mk',
  JPN: 'jp', KOR: 'kr', AUS: 'au', KSA: 'sa', IRN: 'ir', IRQ: 'iq', QAT: 'qa',
  UAE: 'ae', CHN: 'cn', UZB: 'uz', JOR: 'jo', OMA: 'om', BHR: 'bh',
  CMR: 'cm', GHA: 'gh', SEN: 'sn', MAR: 'ma', TUN: 'tn', EGY: 'eg', NGA: 'ng',
  CIV: 'ci', ALG: 'dz', RSA: 'za', MLI: 'ml', BFA: 'bf', CGO: 'cg', ANG: 'ao',
  CPV: 'cv', CUW: 'cw', COD: 'cd',
  NZL: 'nz',
};

/**
 * <Bandeira codigo="BRA" nome="Brasil" />
 * Renderiza a bandeira via flagcdn (img). Se nao mapeado, mostra a sigla/iniciais.
 */
export default function Bandeira({ codigo, nome, tamanho }) {
  const [erro, setErro] = useState(false);
  const iso = codigo ? FIFA_ISO[String(codigo).toUpperCase()] : null;
  const sigla = (codigo || (nome || '').slice(0, 3)).toUpperCase();

  const style = tamanho ? { width: tamanho, height: Math.round(tamanho * 0.74) } : undefined;

  if (!iso || erro) {
    return <div className="torc-bandeira-fallback" style={style} title={nome}>{sigla.slice(0, 3)}</div>;
  }
  return (
    <img
      className="torc-bandeira"
      style={style}
      src={`https://flagcdn.com/w80/${iso}.png`}
      srcSet={`https://flagcdn.com/w160/${iso}.png 2x`}
      alt={nome || sigla}
      title={nome}
      loading="lazy"
      onError={() => setErro(true)}
    />
  );
}
